import { createFileRoute, useRouterState } from '@tanstack/react-router';

import { SectionLayout } from '@/features/app-shell/components/SectionLayout';
import { AI_USAGE_TABS } from '@/features/app-shell/navigation';

// The models a workspace uses, and what they cost, as tabs of one entry (spec 224).
// Two pages still: Spend is for owners and admins, Models for everyone.
export const Route = createFileRoute('/workspaces/$workspaceId/ai-usage')({
  component: AiUsageRoute,
});

// Each tab says what it is for (spec 251): one line for both read as Spend's on Models,
// where a member sees no money.
const MODELS_DESCRIPTION = "Which AI models this workspace's workflows run on.";
const SPEND_DESCRIPTION =
  "What this workspace's runs cost, and where the money went.";

export function AiUsageRoute() {
  const { workspaceId } = Route.useParams();
  const onSpend = useRouterState({
    select: (state) => state.location.pathname.endsWith('/ai-usage/spend'),
  });
  return (
    <SectionLayout
      title="AI usage"
      description={onSpend ? SPEND_DESCRIPTION : MODELS_DESCRIPTION}
      // The period and the view change what both tabs show, so they stand in
      // one place under the tabs on each (spec 224 review).
      toolbar
      // The band every main page of a workspace carries (spec 227).
      surface="inverse"
      tabs={AI_USAGE_TABS}
      workspaceId={workspaceId}
    />
  );
}
